import { DateTime } from 'luxon';
import { APP_LUX_DATE_FORMAT } from './index';

export const formatDbDateTimeToAppDate = (
    dateString: string | null | undefined,
    format: string | undefined = APP_LUX_DATE_FORMAT,
    minusMonth: number | undefined = 0,
): string | null => {
    if (!dateString) {
        return null;
    }

    const dateTime = DateTime.fromSQL(dateString);

    return dateTime.isValid ? dateTime.minus({ months: minusMonth }).toFormat(format) : null;
};
